import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";

import 'common/css/master.css'

import { getClassListSvc, getClassSectionListSvc, getSectionSubjectListSvc, saveClassSectionSvc } from "./staffDtlsSvc";

const ClassSubjectForm = (props) => {
    // const [staffId, setStaffId] = useState(props.staffId)
    const [userId, setUserId] = useState(props.userId);
    const [lstClass, setLstClass] = useState([])
    const [lstClassSection, setLstClassSection] = useState([])
    const [lstSubject, setLstSubject] = useState([])
    const [clsId, setClsId] = useState(props.classId)
    const [sectionId, setSectionId] = useState(props.sectionId)
    const [lstSubjectId, setLstSubjectId] = useState([])
    const [loader, setLoader] = useState(props.loader)
    const [found, setFound] = useState([])
    const [subject, setSubject] = useState("")
    const [flgSelectAllEnabled, setFlgSelectAllEnabled] = useState(false);


    useEffect(() => {
        getClassList();
        getSectionSubjectListSvc(props.userId, props.sectionId, cbSectionSubjectList)
        getClassSectionListSvc(props.classId, cbClassSectionList, props.sectionId)
        setClsId(props.classId)
        setFound([])
        setLstSubjectId([]);
        //setSectionId(props.sectionId)
        // console.log("SLider ClassID" + props.classId + "SLider section Id" + props.sectionId)
    }, [props.flgSliderType, props.sectionId, props.classId, props.userId])




    function getClassList() {
        setLoader("block")
        getClassListSvc(cbClassList)
    }
    function cbClassList(data) {
        if (data.SvcStatus === "Success") {
            setLstClass(data.lstClass)
            // console.log(JSON.stringify(data.lstClass))
        } else {
            toast.error(data.SvcMsg)
        }
        setLoader('none')
    }
    async function handleClsIdChange(param) {
        await setSectionId(0);
        await setLstSubject([])
        await setFound([])
        await setStateLstSubject([]);
        await setLstSubjectId([]);
        await setClsId(param)
        getClassSectionListSvc(param, cbClassSectionList, 0)
    }
    function handleSectionIdChange(param) {
        // console.log("section Id" + param)
        setSectionId(param)
        getSectionSubjectListSvc(props.userId, param, cbSectionSubjectList)
    }
    function cbClassSectionList(data, pSectionId) {
        if (data.SvcStatus === "Success") {
            setLstClassSection(data.lstClassSection)
            if (!pSectionId) {
                if (data.lstClassSection.length)
                    handleSectionIdChange(data.lstClassSection[0].sectionId);
            } else {
                handleSectionIdChange(pSectionId)
            }
        } else {
            toast.error(data.SvcMsg)
        }
        setLoader('none')
    }
    async function cbSectionSubjectList(data) {
        if (data.SvcStatus === 'Success') {
            await setLstSubject(data.lstSubject)
            await setFound(data.lstSubject)
            await setStateLstSubject(data.lstSubject);
            const tempLstSubjectId = data.lstSubject.filter(subject => subject.selected).map(subject => subject.subjectId);
            await setLstSubjectId(tempLstSubjectId);
        }
        else {
            toast.error(data.SvcMsg)
        }
        setLoader('none')
    }
    function setStateLstSubject(pLstSubjectId) {
        var tmpArr = [];
        for (var i = 0; i < pLstSubjectId.length; i++) {
            var obj = pLstSubjectId[i];
            if (obj.selected) {
                tmpArr.push(obj.subjectId)
            }
        }
        // console.log(tmpArr);
        setLstSubjectId(tmpArr);
    }

    async function handleSelectAll() {
    const newSelectAllState = !flgSelectAllEnabled;
    setFlgSelectAllEnabled(newSelectAllState);

    let lstTempArr = [...lstSubjectId];
    
    // If "select all" is enabled, add all subject IDs to the list
    if (newSelectAllState) {
        found.forEach((subject) => {
            if (!lstTempArr.includes(subject.subjectId)) {
                lstTempArr.push(subject.subjectId);
                subject.selected = true;
            }
        });
    } else {
        // If "unselect all", clear the list
        lstTempArr = [];
        found.forEach((subject) => {
            subject.selected = false;
        });
    }

    await setLstSubjectId(lstTempArr); // Update the selected subjects
}

    async function handleCBoxChange(subject_id, status) {
        let lstTempArr = [...lstSubjectId];
        if (status && !lstSubjectId.includes(subject_id)) {
            lstTempArr.push(subject_id);
            await setLstSubjectId(lstTempArr);
            for (let i = 0; i < found.length; i++) {
                if (found[i].subjectId === subject_id) {
                    found[i].selected = true;
                    break; 
                }
            }
        } else {
            const index = lstTempArr.indexOf(subject_id);
            if (index > -1) {
                lstTempArr.splice(index, 1); 
                await setLstSubjectId(lstTempArr);
            }

            for (let i = 0; i < found.length; i++) {
                if (found[i].subjectId === subject_id) {
                    found[i].selected = false;
                    break; 
                }
            }
        }
    }


    function saveClassSection() {
        setLoader("block")
        saveClassSectionSvc(userId, clsId, sectionId, lstSubjectId, cbSaveClassSection)
    }
    function cbSaveClassSection(data, pClassId, pSectionId) {
        setLoader('none')
        if (data.SvcStatus === "Success") {
            toast.success(data.SvcMsg)
            setSubject("");
            props.generateRandomNo()
            props.setClassSubjectTblKey(props.generateRandomNo());
            props.setSelClassId(pClassId)
            props.setSelSectionId(pSectionId)
            // props.closeSlider();
        } else {
            toast.error(data.SvcMsg)
        }
    }


    const filterSubject = (e) => {
        const keyword = e.target.value;
        if (keyword !== '') {
            const results = found.filter((user) => {
                return user.subject.toLowerCase().includes(keyword.toLowerCase());
                // Use the toLowerCase() method to make it case-insensitive
            });
            setFound(results);
            const tempLstSubjectId = results.filter(subject => subject.selected).map(subject => subject.subjectId);
            setLstSubjectId(tempLstSubjectId);
        } else {
            setFound(lstSubject);
            const tempLstSubjectId = lstSubject.filter(subject => subject.selected).map(subject => subject.subjectId);
            setLstSubjectId(tempLstSubjectId);
            // If the text field is empty, show all users
        }
        setSubject(keyword);
    };

    return (
        <form className='form form-horizontal' style={{ width: '100%', overflowX: 'hidden', margin: '0 auto', background: '#fff', border: '1px solid #ccc', borderRadius: 10 }}>
            <div className="col-sm-12" style={{ pointerEvents: loader === "none" ? "auto" : "none" }}>
                <ToastContainer autoClose={3000} hideProgressBar />

                <div style={{ position: 'fixed', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: loader }}>
                    <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
                </div>
                <div className='row' style={{ width: '100%' }}>
                    <div className="form-group col-md-12">
                        <label className="control-label col-sm-3">Class<span className="red-color">*</span></label>
                        <div className='col-sm-3 padding-remove'>
                            <select className="form-control" onChange={(e) => handleClsIdChange(e.target.value)} value={clsId}>
                                <option value={0}>Class</option>
                                {lstClass.map((obj, idx) => {
                                    return <option key={idx} value={obj.clsId}>{obj.cls}</option>
                                })}
                            </select>
                        </div>
                    </div>
                </div>
                <div className='row' style={{ width: '100%' }}>
                    <div className="form-group col-md-12">
                        <label className="control-label col-sm-3">Section<span className="red-color">*</span></label>
                        <div className='col-sm-3 padding-remove'>
                            <select className="form-control" onChange={(e) => handleSectionIdChange(e.target.value)} value={sectionId}>
                                <option value={0}>Section</option>
                                {lstClassSection.map((sec, idx) => {
                                    return <option key={idx} value={sec.sectionId}>{sec.section}</option>
                                })}
                            </select>
                        </div>
                    </div>
                </div>
                <div className='row' style={{ width: '100%' }}>
                    <div className="form-group col-md-12" >
                        <label className="control-label col-sm-3">Subject<span className="red-color">*</span></label>
                        <div className='tablebodyWrapper1' style={{ height: '50vh' }}>
                            <table className='tableLayout1' >
                                <colgroup>
                                    <col width={30} />
                                    <col width={30} />
                                </colgroup>
                                <thead>{
                                    clsId !== 0 && sectionId !== 0 &&
                                    <tr>
                                        <td className="padding-remove"><input onChange={filterSubject} type="text" value={subject} className="form-control inp-search" placeholder="Subject" /></td>
                                    </tr>
                                }
                                </thead>

                                <tbody key={'c_' + clsId + '_sec_' + sectionId}>{

                                    clsId !== 0 && sectionId !== 0 && found.map((sub, idx) => {
                                        return (<tr /*onClick={(e) => handleSelSubjectId(sub.subjectId)} className={sub.subjectId === subjectId ? "selected" : ""}*/ key={idx}>
                                            <td className="text-left">{sub.subject}</td>
                                            <td>
                                                <input
                                                    key={sub.subjectId}
                                                    type="checkbox"
                                                    // defaultChecked={sub.selected}
                                                    checked={lstSubjectId.includes(sub.subjectId)}
                                                    onChange={(e) => handleCBoxChange(sub.subjectId, e.target.checked)}
                                                />
                                            </td>
                                        </tr>);
                                    })
                                }</tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="col-sm-10 padding-remove" style={{ height: "50px", marginTop: "30px" }}>
                    <div className="col-sm-6 col-md-6 padding-remove pull-right">
                        <div className="col-sm-6 col-md-6 padding-remove ">
                            <button type="button" className="btn btn-info btn-space" onClick={(e) => saveClassSection()}>Save</button>
                        </div>
                    </div>
                </div>
                {/* <div className="row" style={{ width: '100%' }}>
                    <button type="button" className="btn btn-info btn-space" onClick={(e) => saveClassSection()}>Save</button>
                </div> */}
            </div>
        </form>
    )
}
export default ClassSubjectForm;